import React from 'react'
import SelectedDepartmentFilter from 'support/filters/SelectedDepartmentFilter'
import ResourceFilter from 'support/filters/ResourceFilter'
import { Translation } from '@morningtrain/react-translations'
import { StaticFilter } from '@morningtrain/react-filters'

export default function ContractTemplateFilter ({ name = 'user_id' }) {
  return (
    <ResourceFilter
      name='contract_template_id'
      resourceName='employments.contract_templates'
      operationName='index'
      optionsKey='name'
      placeholder='-'
      label={<Translation name='fields.contract_template.label' />}
    >
      <StaticFilter name='status' value='active' />
      <SelectedDepartmentFilter />
    </ResourceFilter>
  )
}
